import BackgroundSelection from './BackgroundSelection'

export default BackgroundSelection
